import { NavList } from "./NavList";

/**
 * The desktop navigation rail; MobileNav's drawer takes over below `lg`.
 *
 * Toggled by Tailwind, not a JS breakpoint: the test setup stubs matchMedia to
 * `false`, so a `useIsMobile` would read "desktop" there and never exercise the
 * drawer. Width in rem because `--font-scale` goes to 1.5x.
 */
export function AppSidebar() {
  return (
    <nav
      aria-label="Main"
      className="hidden w-56 shrink-0 self-start lg:sticky lg:top-8 lg:block"
    >
      <NavList />
    </nav>
  );
}
